import {Component, inject, Inject, signal, WritableSignal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {MatTooltip} from "@angular/material/tooltip";
import {ICustomGridRow} from '../../../components/control/table-control/interfaces/custom-grid-row.interface';
import {DisplayedColumns} from '../../../components/control/table-control/interfaces/displayed-columns.interface';
import {IApiCell} from '../../../components/control/table-control/api-cell.interface';
import {ITableVerticalDataGroup,} from '../../../components/control/table-vertical-control/table-vertical-api-adapter';
import {mapRow} from '../../../components/control/table-vertical-control/map-row';
import {
  TableVerticalControlCoreComponent
} from '../../../components/control/table-vertical-control/table-vertical-control-core/table-vertical-control-core.component';
import {ConfirmIconButtonComponent} from '../../../components/confirm-icon-button/confirm-icon-button.component';
import {DialogHeaderComponent} from '../../../components/dialog-header/dialog-header.component';
import {IApiControl} from '../../../../../../nucleus/src/lib/control/interfaces/api-control.interface';
import {IGroupMap} from '../../../../../../nucleus/src/lib/control/base-control-new/signal-control.directive';
import {ControlStore, IControlDataChanged} from '../../../../../../nucleus/src/lib/apiv2/control.store';

@Component({
  selector: 'lib-edit-row-dialog',
  standalone: true,
  imports: [
    DialogHeaderComponent,
    MatDialogContent,
    ConfirmIconButtonComponent,
    MatTooltip,
    MatDialogActions,
    TableVerticalControlCoreComponent,
  ],
  templateUrl: './edit-row-dialog.component.html',
  styleUrl: './edit-row-dialog.component.scss',
})
export class EditRowDialogComponent {
  groups: WritableSignal<ITableVerticalDataGroup[]> = signal<ITableVerticalDataGroup[]>([]);
  protected readonly controlStore: ControlStore = inject(ControlStore);

  constructor(
    public dialogRef: MatDialogRef<EditRowDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      GUID: string,
      row: ICustomGridRow,
      columns: DisplayedColumns[],
      apiInstance: IApiControl,
      groupMap: IGroupMap,
    },
  ) {

    this.groups.set(mapRow(this.data.row.apiRow, this.data.columns, this.data.apiInstance, this.data.groupMap));
  }

  onConfirm(): void {
    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSelectionDataChange(evt: IControlDataChanged): void {
    this.controlStore.controlDataChanged$.emit({changeType: evt.changeType, GUID: this.data.GUID});
  }
}
